import React from "react";
import EffectTable from "./index";
import UnconfiguredComponent from "../common3/UnconfiguredComponent";

import isEmpty from "lodash/isEmpty";

const EffectTableEdit = (props) => {
  const { extra = {}, builder = false } = props;
  const { options = null, optionsType } = extra;

  if (!extra.effects) {
    return <UnconfiguredComponent hint="Effect.AddEffect" />;
  }

  if (!extra.configuration) {
    return <UnconfiguredComponent hint="EffectTable.AddTableConfiguration" />;
  }

  return <EffectTable {...props} />;
};

export default EffectTableEdit;
